// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f93c8b41","160":"e42de8ee","208":"2ab3b8fb","293":"8233d223","516":"fcd60811","519":"14d70b67","917":"53c73b79","946":"52b457ab"}[chunkId] + ".chunk.js";
};